// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3XKg9","search":"Settings_search__1sVuW","filter":"Settings_filter__2faJO"};